import { META_KEY } from 'contracts/constants';
import type { ICollectionType, ISchema } from 'contracts/interfaces';
import { isEmpty } from 'lodash';
import { isValidFieldName } from 'utils';

export const isValidateRootField = (s: {}) => {
  if (isEmpty(s)) {
    return false;
  }
  if (!isValidFieldName.test(Object.keys(s)[0])) {
    return false;
  }

  return true;
};

export const typeGuard = (toBeDetermine: ISchema) => {
  if (typeof toBeDetermine === 'string') {
    return toBeDetermine;
  }
  if (META_KEY in toBeDetermine) {
    return (toBeDetermine as ICollectionType)[META_KEY].type;
  }
  if (toBeDetermine.type) {
    if (typeof toBeDetermine.type === 'string') {
      return toBeDetermine.type;
    }

    return Object.keys(toBeDetermine.type)[0];
  }

  return 'unknown';
};
